import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// import TeamImage from './TeamImage.png'
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";
import {
  fetchMenusIfNeeded,
  selectCustomPage,
  fetchCustomPageIfNeeded,
  CLIENT_BASE_URL
} from "../../actions";

export class TemplateMosaic extends React.Component {
  constructor(props) {
    super(props);
    this.gotoPage = this.gotoPage.bind(this);
  }

  drawBackgroundImage(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  componentWillMount(p) {
    const { match, dispatch } = this.props;

    if (Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]));
      dispatch(fetchCustomPageIfNeeded(match.params[0]));
    } else {
      dispatch(selectCustomPage(""));
    }
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    if (Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]));
    } else {
      dispatch(selectCustomPage(""));
    }
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    const { selectedCustomPage } = this.props;

    if (
      Object.keys(match.params).length &&
      selectedCustomPage !== match.params[0]
    ) {
      dispatch(selectCustomPage(match.params[0]));
      dispatch(fetchCustomPageIfNeeded(match.params[0]));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(selectCustomPage(""));
  }

  gotoPage(page) {
    this.props.history.push("/pesquisa");
  }

  renderCards(cards) {
    let cardBlock = [];
    let cardList = [];

    if (cards.length <= 3) {
      return <div className="row">{this.renderCardDOM(0, cards)}</div>;
    }

    return cards.map((card, i) => {
      // console.log('renderCards', card)
      // acumula de três em três
      cardBlock = cardBlock.concat(card);
      if ((i + 1) % 3 === 0) {
        cardList = cardBlock;
        cardBlock = [];
        return <div className="row">{this.renderCardDOM(i, cardList)}</div>;
      }
    });
  }

  renderCardDOM(i, cards) {
    // console.log('renderCardDOM', cards)
    return cards.map((card, j) => {
      if (card.movie_id !== 0) {
        return (
          <Link to={`/filme/${card.movie_id}`}>
            <div
              key={`w${i}.${j}`}
              className="mosaic col-sm-6 col-md-4 col-lg-4"
            >
              <div key={`c${i}.${j}`} className="col-sm-4 no-pad-right">
                <img src={`${CLIENT_BASE_URL}${card.thumb}`} />
              </div>
              <div key={`d${i}.${j}`} className="col-sm-8">
                <p style={{ fontWeight: "700" }}>{card.title}</p>
                <p key={`p${i}.${j}`}>{card.description}</p>
              </div>
            </div>
          </Link>
        );
      }
      return (
        <div key={`w${i}.${j}`} className="mosaic col-sm-6 col-md-4 col-lg-4">
          <div key={`c${i}.${j}`} className="col-sm-4 no-pad-right">
            <img src={`${CLIENT_BASE_URL}${card.thumb}`} />
          </div>
          <div key={`d${i}.${j}`} className="col-sm-8">
            <p style={{ fontWeight: "700" }}>{card.title}</p>
            <p key={`p${i}.${j}`}>{card.description}</p>
          </div>
        </div>
      );
    });
  }

  renderExtraSection(title, htmlTxt) {
    if (!title) {
      return;
    }

    return (
      <div className="row" style={{ paddingTop: "40px" }}>
        <div className="col-md-12 no-pad text-left">
          <p className="left-tag">{title}</p>
        </div>
        <div className="main-block col-md-12 no-pad-left">
          <p dangerouslySetInnerHTML={{ __html: htmlTxt }} />
        </div>
      </div>
    );
  }

  render() {
    const { menus, dispatch } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const { details } = this.props;
    if (!Object.keys(details).length) {
      return <div />;
    }

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="presentation-view" className="row team-view">
          <div className="col-md-12 no-pad text-left">
            <p className="left-tag">{details["0"].title}</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row main-block mosaic-container">
            {this.renderCards(details.cards)}
          </div>
          {this.renderExtraSection(
            details["0"].subsection_title,
            details["0"].subsection_html
          )}
        </div>

        <FooterLinks bottom_menus={bottom_menus} />
        <SocialView customclass="lite" />
        <FooterNote />
      </div>
    );
  }
}

TemplateMosaic.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  details: PropTypes.object.isRequired,
  selectedCustomPage: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const { getMenus, selectedCustomPage, getCustomPage, selectedScope } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingCPage, items: details } = getCustomPage[
    selectedCustomPage
  ] || {
    isFetchingCPage: true,
    items: {}
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingCPage,
    details,
    selectedCustomPage,
    selectedScope
  };
}

export default connect(mapStateToProps)(TemplateMosaic);



// WEBPACK FOOTER //
// ./src/views/AboutView/TemplateMosaic.js